module.exports = __webpack_public_path__ + "img/dice.d37aa2de.gif";